export const classGroup = [
  { _id: 0, title: "All" },
  { _id: 1, title: "Class" },
  { _id: 2, title: "Category" },
  { _id: 3, title: 'Staff' }
];

export const attendanceStatus = [
  { _id: 0, title: "Check-in" },
  { _id: 1, title: "Absent" },
  { _id: 2, title: "Check-out" },
];

